module.exports = __webpack_public_path__ + "static/img/send-icon.23b36f4e.png";